<div class="modal-header">
  <h4 class="modal-title pull-left">Create IBIS Report</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <label>Pick IBIS Report</label>
  <dropdown-input-search [provider]="ibisProvider" [displayFull]="true"
    placeholder="Search IBIS World" (valueChange)="onValueChanged($event)"
    style="width: 100%;"></dropdown-input-search>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button type="button" [disabled]="!value" class="btn btn-rbv" (click)="onConfirm()">Ok</button>
</div>
